import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CustomRouteService } from 'src/app/pages/custom-route/services';
import { EditRouteService } from 'src/app/pages/custom-route/shared/planner/components/route-timeline/components/daily-route-list/services';


@Injectable({
  providedIn: 'root'
})
export class RestoreCustomRoute {
  private _customRouteService = inject(CustomRouteService);
  private _editRouteService = inject(EditRouteService);
  
  private _originalCustomRouteData = this._customRouteService.originalCustomRouteData;
  private _editedCustomRouteData = this._editRouteService.editedCustomRouteData;
  private _errorEditedCustomRouteData = this._editRouteService.errorEditedCustomRouteData;
  
  public restoreRoute(): Observable<{ is_successful: boolean }> {
    
    const route = this._editedCustomRouteData() ?? this._originalCustomRouteData();

    if (!route?.dailyRoutes) {
      return of({ is_successful: false, reason: this._errorEditedCustomRouteData() });
    }

    return of({ is_successful: true });
  }
}
